var FrigerioGalleryLightbox = {
    init: function() {
        this.createOverlays();
        this.bindEvents();
    },

    createOverlays: function() {
        jQuery('.wrapper-gallery').each(function() {
            if (jQuery(this).find('.overlay-gallery').length === 0) {
                var $overlay = jQuery('<div class="overlay-gallery"></div>');
                var $wrapperOverlay = jQuery('<div class="wrapper-overlay"></div>');
                var $image = jQuery("<img>");
                var $prevButton = jQuery('<div class="prevButton"></div>');
                var $nextButton = jQuery('<div class="nextButton"></div>');
                
                $overlay.append($wrapperOverlay).prepend($prevButton).append($nextButton);
                $wrapperOverlay.append($image);
                jQuery(this).append($overlay);
                
                $overlay.hide();
            }
        });
    },

    bindEvents: function() {
        jQuery(document).on('click', ".wrapper-gallery .wrapper-image a", this.openLightbox);
        jQuery(document).on('click', '.overlay-gallery', this.closeLightbox);
        jQuery(document).on('click', '.overlay-gallery .nextButton', this.nextImage);
        jQuery(document).on('click', '.overlay-gallery .prevButton', this.prevImage);

        jQuery(document).on('keydown', function(event) {
            var $activeOverlay = jQuery('.overlay-gallery:visible');
            if ($activeOverlay.length > 0) {
                if (event.key === 'Escape') {
                    $activeOverlay.fadeOut("slow");
                } else if (event.key === 'ArrowRight') {
                    $activeOverlay.find('.nextButton').trigger("click");
                } else if (event.key === 'ArrowLeft') {
                    $activeOverlay.find('.prevButton').trigger("click");
                }
            }
        });
    },

    openLightbox: function(event) {
        event.preventDefault();
        var $this = jQuery(this);
        var imageLocation = $this.attr("href");
        var $gallery = $this.closest('.wrapper-gallery');
        var $overlay = $gallery.find('.overlay-gallery');
        var $image = $overlay.find('.wrapper-overlay img');

        $image.attr("src", imageLocation).on('error', function() {
            $image.attr("src", "path-to-fallback-image.jpg");
        });

        $overlay.css('display', 'flex');
    },

    closeLightbox: function(event) {
        if (event.target === this) {
            jQuery(this).fadeOut("slow");
        }
    },

    nextImage: function(event) {
        event.stopPropagation();
        var $overlay = jQuery(this).closest('.overlay-gallery');
        var $currentImg = $overlay.find("img");
        var $currentSrc = $currentImg.attr("src");
        var $gallery = $overlay.closest('.wrapper-gallery');
        var $images = $gallery.find(".wrapper-image img");
        var $currentIndex = $images.index($images.filter('[src="' + $currentSrc + '"]'));
        var nextIndex = ($currentIndex + 1) % $images.length;
        $currentImg.attr("src", $images.eq(nextIndex).attr("src"));
    },
    
    prevImage: function(event) {
        event.stopPropagation();
        var $overlay = jQuery(this).closest('.overlay-gallery');
        var $currentImg = $overlay.find("img");
        var $currentSrc = $currentImg.attr("src");
        var $gallery = $overlay.closest('.wrapper-gallery');
        var $images = $gallery.find(".wrapper-image img");
        var $currentIndex = $images.index($images.filter('[src="' + $currentSrc + '"]'));
        var prevIndex = ($currentIndex - 1 + $images.length) % $images.length;

        $currentImg.attr("src", $images.eq(prevIndex).attr("src"));
    }
};

jQuery(document).ready(function() {
    FrigerioGalleryLightbox.init();
});